<template>
  <div>
    <div class="sayfahead">
      <h1>Arızalı Sayaç Raporu</h1>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-col :span="21">
            <el-input size="small" placeholder="Telegram Kodunu Giriniz" v-model="Telegram"></el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                       icon="el-icon-check">Çözümle
            </el-button>
          </el-col>
        </el-row>
      </div>
      <hr>
      <el-alert
        v-if="!TelegramCevap"
        title="Örnek Telegram"
        type="info"
        :closable="false"
        description="685a5a68080072976412148f4102043d0000000c06000000000c06926501000c14561928000c14000000000b592356000b5d8135000c2d040000000c3b220000000c26942301003c22000000000c2233560500066d000411a721000f0000a516"
      >
      </el-alert>
      <div class="scrollkaydir">
      <JsonV
        v-if="TelegramCevap"
        :value="TelegramCevap"
        sort
        :expand-depth=5
        :copyable="{copyText: 'Kopyala', copiedText: 'Kopyalandı!', timeout: 2000}"
      ></JsonV>
      </div>
    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";
import JsonV from 'vue-json-viewer'
export default {
  components: {Yukleniyor,JsonV},
  data() {
    return {
      Telegram: '685a5a68080072976412148f4102043d0000000c06000000000c06926501000c14561928000c14000000000b592356000b5d8135000c2d040000000c3b220000000c26942301003c22000000000c2233560500066d000411a721000f0000a516',
      lo: false,
      TelegramCevap: null
    }
  },
  methods: {
    Getir() {
      this.lo = true;
      this.$store.dispatch("Post", {Telegram: this.Telegram, path: '_enerji/rapor/telegram'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.TelegramCevap = response.TelegramCevap
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/Telegram.vue